import React, { useState } from "react";
import "./login_form.css";
import crypto from "crypto";
import { useSidebar } from "../../ui/sidebar";
import { Stack, Input } from "@mui/material";
import LoadingScreenDenda from "../Animation/loading_screen";
import { post } from "../../../lib/api";

const LoginForm = () => {
  const { authenticated, setAuthenticated, setUser } = useSidebar();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false); //set state for showing password
  const [loginError, setLoginError] = useState(false);
  const [loading, setLoading] = useState(false); // State for controlling the loading screen

  // Function to hash password
  const hashPassword = (password) => {
    const hash = crypto.createHash("sha256");
    hash.update(password);
    return hash.digest("hex");
  };

  // Function to handle the login process
  const handleLogin = async () => {
    setLoading(true);
    const hashedPassword = hashPassword(password);
    const postData = {
      username: username,
      hash: hashedPassword,
    };
    const data = await post(postData, "/login");

    if (data["isValid"]) {
      setAuthenticated(data["isValid"]);
      setUser(data["user"]);
    } else {
      setLoginError(true);
      setTimeout(() => setLoginError(true), 3000); // Reset loginError after 3 seconds
    }
    setLoading(false);
  };

  // Function to handle the logout process
  const handleLogout = () => {
    post({}, "/logout");

    // localStorage.clear();
    setAuthenticated(false);
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      handleLogin();
    }
  };

  return (
    <Stack spacing="var(--spacing-S)">
      <Stack spacing={"var(--spacing-XXS)"}>
        <div className="login-container">
          {loading ? ( // Show loading component when loading is true
            <LoadingScreenDenda text={"Loading"} />
          ) : authenticated ? ( // Conditionally render only when not loading and not authenticated
            <div className="login-form">
              <div className="form-group">
                <Input value={""} disabled className={"input-disabled"} />
              </div>
              <div className="form-group">
                <Input value={""} disabled className={"input-disabled"} />
              </div>
              <div>
                <button type="submit" style={{ marginTop: "8px" }} className="logout-button" onClick={handleLogout}>
                  LOG OUT
                  {/*{loading && <Loading_icon text="Logging out"/>}*/}
                </button>
              </div>
            </div>
          ) : (
            <div className="login-form">
              <div className="form-group">
                <Input
                  type="username"
                  placeholder="Username"
                  required
                  value={username}
                  onKeyPress={handleKeyPress} // Add key press handler
                  onChange={(e) => setUsername(e.target.value)}
                  className={loginError ? "input-error" : ""}
                />
              </div>
              <div className="form-group">
                {/* Input for the password with conditional type based on showPassword state */}
                <Input
                  type={showPassword ? "text" : "password"}
                  placeholder="Password"
                  required
                  onKeyPress={handleKeyPress} // Add key press handler
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  className={loginError ? "input-error" : ""}
                  // endAdornment={
                  //     <InputAdornment position="start">
                  //         <IconButton onClick={() => setShowPassword(!showPassword)}
                  //                     // edge="end"
                  //             >
                  //             {showPassword ? <VisibilityIcon/> : <VisibilityOffIcon/>}
                  //         </IconButton>
                  //     </InputAdornment>
                  // }
                />
              </div>
              <button type="submit" className="login-button" onClick={handleLogin} onKey>
                LOG IN
                {/*{loading && <Loading_icon text="Logging in"/>}*/}
              </button>
              <div className={loginError ? "error-message" : ""}>{loginError ? "Wrong username or password." : ""}</div>
            </div>
          )}
          {/*{loading && <Loading_icon/>}*/}
        </div>
      </Stack>
    </Stack>
  );
};

export default LoginForm;
